import api from './api';
import type { CreatePromptData, Prompt, PromptDetail, UpdatePromptData } from '../types';

export const promptService = {
  getAll: async (): Promise<Prompt[]> => {
    const response = await api.get<Prompt[]>('/admin/prompts');
    return response.data;
  },

  getOne: async (key: string): Promise<PromptDetail> => {
    const response = await api.get<PromptDetail>(`/admin/prompts/${encodeURIComponent(key)}`);
    return response.data;
  },

  suggestKey: async (name: string): Promise<string> => {
    const response = await api.get<{ key: string }>('/admin/prompts/suggest-key', { params: { name } });
    return response.data.key;
  },

  create: async (data: CreatePromptData): Promise<Prompt> => {
    const response = await api.post<Prompt>('/admin/prompts', data);
    return response.data;
  },

  update: async (key: string, data: UpdatePromptData): Promise<Prompt> => {
    const response = await api.put<Prompt>(`/admin/prompts/${encodeURIComponent(key)}`, data);
    return response.data;
  },

  delete: async (key: string): Promise<void> => {
    await api.delete(`/admin/prompts/${encodeURIComponent(key)}`);
  },

  rollback: async (key: string, version: number): Promise<Prompt> => {
    const response = await api.post<Prompt>(
      `/admin/prompts/${encodeURIComponent(key)}/rollback/${version}`,
    );
    return response.data;
  },
};
